interface UndoButtonsProps {
  readonly canUndo: boolean;
  readonly canRedo: boolean;
  readonly onUndo: () => void;
  readonly onRedo: () => void;
}

/** Undo / redo of unsaved edits; the keyboard shortcuts work in the grid as well. */
export function UndoButtons({ canUndo, canRedo, onUndo, onRedo }: UndoButtonsProps) {
  return (
    <span className="undo-buttons">
      <button
        type="button"
        className="button button--ghost"
        disabled={!canUndo}
        onClick={onUndo}
        aria-keyshortcuts="Control+Z Meta+Z"
        title="ביטול פעולה (Ctrl/Cmd+Z)"
      >
        <span aria-hidden="true">↶</span> ביטול פעולה
      </button>
      <button
        type="button"
        className="button button--ghost"
        disabled={!canRedo}
        onClick={onRedo}
        aria-keyshortcuts="Control+Shift+Z Meta+Shift+Z Control+Y"
        title="ביצוע מחדש (Ctrl/Cmd+Shift+Z)"
      >
        <span aria-hidden="true">↷</span> ביצוע מחדש
      </button>
    </span>
  );
}
